import feathersClient from "../../feathers-client";

const defaultHiFiAwardReasonPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultHiFiAwardReasonPaginationFilter = {
	$skip:defaultHiFiAwardReasonPagination.$skip,
	$limit: defaultHiFiAwardReasonPagination.$limit
};

export default {
	state:{
		HiFiAwardReason:[],
		HiFiAwardReasonPagination:defaultHiFiAwardReasonPagination,
		HiFiAwardReasonPaginationFilter:defaultHiFiAwardReasonPaginationFilter
	},
	getters:{
		setHiFiAwardReasonPage:(state) => {
			const {$limit, $skip} = state.HiFiAwardReasonPagination;
			return $skip / $limit + 1;
		}

	},
	mutations:{
		SET_HIFIAWARD_REASON:(state,data) => {state.HiFiAwardReason = data;},
		SET_HIFIAWARD_REASON_PAGINATION:(state, data) => {state.HiFiAwardReasonPagination = {...state.HiFiAwardReasonPagination, ...data};},
		SET_HIFIAWARD_REASON_PAGINATION_FILTER:(state,data) => {state.HiFiAwardReasonPaginationFilter  = {...state.HiFiAwardReasonPaginationFilter, ...data};}

	},
	actions:{
		setHiFiAwardReasonListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.HiFiAwardReasonPagination.$limit;
			commit('SET_HIFIAWARD_REASON_PAGINATION', { $skip });
			commit('SET_HIFIAWARD_REASON_PAGINATION_FILTER', { $skip });
		},

		getHiFiAwardReason: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/hi-fi-award-reasons').find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter
				}
			});
			commit('SET_HIFIAWARD_REASON',results.data);
			commit('SET_HIFIAWARD_REASON_PAGINATION', {total :results.total})
			return results.data;
		},
		createHiFiAwardReason: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/hi-fi-award-reasons').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateHiFiAwardReason: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/hi-fi-award-reasons').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		deleteHiFiAwardReason: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/hi-fi-award-reasons').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getHiFiAwardReasonById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/hi-fi-award-reasons').get(id,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});

			return results
		},
		getAllHiFiAwardReasonForTrust: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/hi-fi-award-reasons').find({
				query:{
					$role:rootGetters.currentUserRole,

				}
			});
			return results;
		},
		getAllHiFiAwardsReason: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/hi-fi-award-reasons').find({
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results.data;
		}

	}
}
